export default class SatisfactionFormsFill {
  constructor() {
    this.bindEvents();
    this.initializeRatings();
    this.setDefaultRecommendation();
    this.checkFormValidity();
  }

  bindEvents() {
    $('.star-rating').each((index, ratingContainer) => {
      const $ratingContainer = $(ratingContainer);
      const $stars = $ratingContainer.find('.star');
      const $hiddenInput = $ratingContainer.find('.star-rating-value');

      $stars.on('click', (event) => {
        const value = Number.parseInt($(event.target).closest('.star').data('value'));
        $hiddenInput.val(value);
        this.updateStars($ratingContainer, value);
        this.checkFormValidity();
      });

      $stars.on('mouseenter', (event) => {
        const value = Number.parseInt($(event.target).closest('.star').data('value'));
        this.highlightStars($ratingContainer, value);
      });

      $stars.on('mouseleave', () => {
        const currentValue = Number.parseInt($hiddenInput.val()) || 0;
        this.updateStars($ratingContainer, currentValue);
      });
    });

    $('input[name="satisfaction_form[would_recommend]"]').on('change', () => {
      this.checkFormValidity();
    });

    $('form').on('input change', () => {
      this.checkFormValidity();
    });

    $('form').on('submit', (e) => {
      if (!this.validateForm()) {
        e.preventDefault();
        alert('Veuillez remplir tous les champs obligatoires.');
      }
    });
  }

  initializeRatings() {
    $('.star-rating').each((index, ratingContainer) => {
      const $ratingContainer = $(ratingContainer);
      const $hiddenInput = $ratingContainer.find('.star-rating-value');
      const currentValue = Number.parseInt($hiddenInput.val()) || 0;
      if (currentValue > 0) {
        this.updateStars($ratingContainer, currentValue);
      }
    });
  }

  updateStars($container, value) {
    const $stars = $container.find('.star');
    $stars.each((index, star) => {
      const $icon = $(star).find('i');
      if (index < value) {
        $icon.removeClass('mdi-star-outline text-muted').addClass('mdi-star text-warning');
      } else {
        $icon.removeClass('mdi-star text-warning').addClass('mdi-star-outline text-muted');
      }
    });
  }

  highlightStars($container, value) {
    const $stars = $container.find('.star');
    $stars.each((index, star) => {
      const $icon = $(star).find('i');
      if (index < value) {
        $icon.removeClass('mdi-star-outline text-muted').addClass('mdi-star text-warning');
      } else {
        $icon.removeClass('mdi-star text-warning').addClass('mdi-star-outline text-muted');
      }
    });
  }

  setDefaultRecommendation() {
    if (!$('input[name="satisfaction_form[would_recommend]"]:checked').length) {
      $('#would_recommend_yes').prop('checked', true);
    }
  }

  checkFormValidity() {
    const isValid = this.validateForm();
    $('button[type="submit"]').prop('disabled', !isValid);
  }

  validateForm() {
    let starsValid = true;
    $('.star-rating-value').each((index, input) => {
      const val = Number.parseInt($(input).val());
      if (Number.isNaN(val) || val <= 0) {
        starsValid = false;
        return false;
      }
    });

    const radioChecked = $('input[name="satisfaction_form[would_recommend]"]:checked').length > 0;
    const reasonFilled = $('#satisfaction_form_recommendation_reason').val().trim() !== '';
    const commentsFilled = $('#satisfaction_form_comments_suggestions').val().trim() !== '';
    const functionFilled = $('#satisfaction_form_customer_function').val().trim() !== '';

    const anonymousFirstName = $('#satisfaction_form_anonymous_first_name');
    const anonymousLastName = $('#satisfaction_form_anonymous_last_name');
    const anonymousCompanyName = $('#satisfaction_form_anonymous_company_name');

    let anonymousValid = true;
    if (anonymousFirstName.length) {
      anonymousValid = anonymousFirstName.val().trim() !== '' &&
                       anonymousLastName.val().trim() !== '' &&
                       anonymousCompanyName.val().trim() !== '';
    }

    return starsValid && radioChecked && reasonFilled && commentsFilled && functionFilled && anonymousValid;
  }

  onDataChanged(data) {
  }

  onDestroy() {
  }
}
